import { h } from 'preact';

import Tab from './tab';

const TabGroup = ({ activeTab, handleTabClick, tabs }) => (
  <div className="border-gray-100 flex justify-around border-b">
    {tabs.map((tab) => (
      <Tab
        key={tab.id}
        tab={tab}
        activeTab={activeTab}
        handleTabClick={handleTabClick}
      />
    ))}
  </div>
);

export default TabGroup;
